import React from 'react'
import SideBar from '../components/SideBar'
import DetailsHeaderBar from '../components/DetailsHeaderBar'
import DetailsTopBar from '../components/DetailsTopBar'
import { useLocation, useNavigate } from 'react-router-dom';
import TransactionHistory from '../components/TransactionHistory';

function AdvertisingAgentTransaction() {
    const location = useLocation();
    const agent = location.state?.agent;
    const navigate = useNavigate();

    if (!agent) {
        return <p style={{ padding: "30px" }}>No agent data available.</p>;
    }

    // Define all possible tabs
  const allTabs = [
    {
      key: "personal",
      label: "Personal Details",
      path: "/business-agent-details",
    },
    {
      key: "wallet",
      label: "Wallet Details",
      path: "/business-agent-wallet-details",
    },
    {
      key: "invitation",
      label: "Invitation Details",
      path: "/business-agent-invitation-details",
      showWhen: "approved",
    },
    {
      key: "request",
      label: "Promote / Demote",
      path: "/business-agent-request-history",
    },
  ];

  // Filter tabs based on status
  const getTabsByStatus = (agentStatus) => {
    return allTabs.filter((tab) => {
      if (!tab.showWhen) return true; // Always show tabs without conditions
      return tab.showWhen === agentStatus;
    });
  };

  // Usage
  const tabs = getTabsByStatus(agent.status);

  
    return (
        <div className="member-details-layout">
            <SideBar />
            <div className="member-details-main">
                <DetailsHeaderBar
                    title="Advertising Agent Details"
                    subtitle="Agent Commission Wallet Transaction History"
                    breadcrumbs={[
                        {label: "Home", path: "/dashboard"},
                        {label: "Manage Advertising Agent", path: "/manage-advertising-agent"},
                        {label: "Transaction History"}
                    ]}
                />
                <DetailsTopBar
                    tabs={tabs}
                    activeTab="wallet"
                    agent={agent}
                />

                <TransactionHistory agent={agent} />
            </div>
        </div>
    )
}

export default AdvertisingAgentTransaction